import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["passwordField", "showIcon", "hideIcon"]

  toggle() {
    if (this.passwordFieldTarget.type === "password") {
      this.passwordFieldTarget.type = "text"
      this.showIconTarget.classList.add("hidden")
      this.hideIconTarget.classList.remove("hidden")
    } else {
      this.passwordFieldTarget.type = "password"
      this.hideIconTarget.classList.add("hidden")
      this.showIconTarget.classList.remove("hidden")
    }
  }
}